import {dateFormatServer, dpParseDate} from '../filters'
import BaseModel from './baseModel'

const anno_inizio_def = 1920
const anno_fine_def = 1990

export default class Fund extends BaseModel {
  interviewers = {}
  donors = {}
  filmFormats = {}
  fundimages = {}

  constructor (create, data) {
    super()
    if (create) {
      this.isNew = true
      this.range_anni = [anno_inizio_def, anno_fine_def]
      this.note_generali = this.emptyNote
      this.note_descrizione = this.emptyNote
      this.note_biografiche = this.emptyNote
      this.note_archivista = this.emptyNote
      this.acquisizione_note = this.emptyNote
    }
    if (data !== undefined) {
      data.acquisizione_data = dpParseDate(data.acquisizione_data)
      let anno_inizio = data.anno_inizio !== null ? data.anno_inizio : anno_inizio_def
      let anno_fine = data.anno_fine !== null ? data.anno_fine : anno_fine_def
      data.range_anni = [anno_inizio, anno_fine]
      Object.entries(data).forEach(([key, value]) => {
        this[key] = value
      })
    }
  }

  prepareForSend () {
    let data = _.cloneDeep(this)
    data.acquisizione_data = dateFormatServer(data.acquisizione_data)
    data.anno_inizio = data.range_anni[0]
    data.anno_fine = data.range_anni[1]
    return data
  }

  prepareQueryForSearch () {
    // this.anno_inizio = (this.range_anni[0] !== anno_inizio_def) ? this.range_anni[0] : null
    // this.anno_fine = (this.range_anni[1] !== anno_fine_def) ? this.range_anni[1] : null
    return super.prepareQueryForSearch(this)
  }
}



// WEBPACK FOOTER //
// ./src/models/fund.js